import React, { useEffect } from 'react';
import { Flex, Text, Pane } from '@leverege/ui-elements';
import { useWizard } from '@leverege/ui-wizard';
import S from './Pair.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function TagUnactivated() {
  const {
    setNextText,
    setBackText,
    setHeader
  } = useWizard();
  useEffect(() => {
    // Set the header title using the wizard context
    setHeader('Pair Asset To Tag');
    setNextText('Select Another Tag');
    setBackText('Cancel');
    return () => {
      setNextText(null);
      setBackText(null);
      setHeader(null);
    };
  }, [setNextText, setBackText, setHeader]);
  return /*#__PURE__*/_jsxs(Flex, {
    variant: "colL",
    children: [/*#__PURE__*/_jsx("img", {
      src: "https://storage.googleapis.com/recovr-ui-assets/tag-warning.png",
      alt: "Tag warning",
      height: 80,
      width: 80
    }), /*#__PURE__*/_jsx(Text, {
      variant: "formTitle",
      children: "Tag is Not Activated"
    }), /*#__PURE__*/_jsx(Text, {
      children: "You must activate a tag to pair it to a vehicle."
    }), /*#__PURE__*/_jsx(Pane, {
      variant: "dashboardCard",
      children: /*#__PURE__*/_jsx(Pane, {
        variant: "dataCard",
        children: /*#__PURE__*/_jsxs(Flex, {
          variant: "colM",
          children: [/*#__PURE__*/_jsxs(Flex, {
            variant: "rowM",
            children: [/*#__PURE__*/_jsx(Text, {
              className: S.ordinal,
              variant: "groupingsCount",
              children: "1"
            }), /*#__PURE__*/_jsx("div", {
              style: {
                flexGrow: 1
              },
              children: /*#__PURE__*/_jsx(Text, {
                children: /*#__PURE__*/_jsx("b", {
                  children: "Activate the Tag"
                })
              })
            })]
          }), /*#__PURE__*/_jsx("div", {
            style: {
              flexGrow: 1
            },
            children: /*#__PURE__*/_jsx(Text, {
              children: "Press the button on the front of the tag three times."
            })
          })]
        })
      })
    }), /*#__PURE__*/_jsx(Pane, {
      variant: "dashboardCard",
      children: /*#__PURE__*/_jsx(Pane, {
        variant: "dataCard",
        children: /*#__PURE__*/_jsxs(Flex, {
          variant: "colM",
          children: [/*#__PURE__*/_jsxs(Flex, {
            variant: "rowM",
            children: [/*#__PURE__*/_jsx(Text, {
              className: S.ordinal,
              variant: "groupingsCount",
              children: "2"
            }), /*#__PURE__*/_jsx("div", {
              style: {
                flexGrow: 1
              },
              children: /*#__PURE__*/_jsx(Text, {
                children: /*#__PURE__*/_jsx("b", {
                  children: "Confirm that the Tag is Activated"
                })
              })
            })]
          }), /*#__PURE__*/_jsx("div", {
            style: {
              flexGrow: 1
            },
            children: /*#__PURE__*/_jsx(Text, {
              children: "Hold down the button on the front of the tag. The light on the sides should turn green, confirming that it is activated."
            })
          })]
        })
      })
    }), /*#__PURE__*/_jsx(Pane, {
      variant: "dashboardCard",
      children: /*#__PURE__*/_jsx(Pane, {
        variant: "dataCard",
        children: /*#__PURE__*/_jsxs(Flex, {
          variant: "colM",
          children: [/*#__PURE__*/_jsxs(Flex, {
            variant: "rowM",
            children: [/*#__PURE__*/_jsx(Text, {
              className: S.ordinal,
              variant: "groupingsCount",
              children: "3"
            }), /*#__PURE__*/_jsx("div", {
              style: {
                flexGrow: 1
              },
              children: /*#__PURE__*/_jsx(Text, {
                children: /*#__PURE__*/_jsx("b", {
                  children: "Bring the Tag in Range"
                })
              })
            })]
          }), /*#__PURE__*/_jsx("div", {
            style: {
              flexGrow: 1
            },
            children: /*#__PURE__*/_jsx(Text, {
              children: "The tag should be ready to pair the next time it is in range of an indoor zone."
            })
          })]
        })
      })
    }), /*#__PURE__*/_jsx(Text, {
      variant: "link",
      children: /*#__PURE__*/_jsx("a", {
        target: "_blank",
        href: "https://help.equipment.recovr.biz/en/articles/8505499-tag-activation-usage",
        rel: "noreferrer",
        children: "Read the Documentation"
      })
    })]
  });
}

// Add the TYPE property for registration
TagUnactivated.TYPE = 'recovr.TagUnactivated';